"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Checkbox = exports.CHECKBOX_STATES = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _ValidationTooltip = require("../Tooltip/_ValidationTooltip");
var _messages = require("../utils/messages");
var _console = _interopRequireDefault(require("../utils/console"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _Checkbox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox.css") : void 0);
var _excluded = ["checked", "className", "disabled", "hiddenLabel", "indeterminate", "inline", "inputProps", "label", "labelProps", "onChange", "required", "size", "validationMessage", "inputRef", "isControlled", "innerTextClassName"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-checkbox';
var CHECKBOX_STATES = exports.CHECKBOX_STATES = ['unselected', 'selected', 'indeterminate'];

/** **Checkbox** is a specialized form control that emits an
 * `<input>` with a type of checkbox. */

var Checkbox = exports.Checkbox = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context, _context2;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Checkbox, _props)) : _props;
  var checked = props.checked,
    className = props.className,
    disabled = props.disabled,
    hiddenLabel = props.hiddenLabel,
    indeterminate = props.indeterminate,
    inline = props.inline,
    inputProps = props.inputProps,
    label = props.label,
    labelProps = props.labelProps,
    _onChange = props.onChange,
    required = props.required,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    validationMessage = props.validationMessage,
    inputRef = props.inputRef,
    isControlled = props.isControlled,
    innerTextClassName = props.innerTextClassName,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var localInputRef = (0, _react.useRef)();
  var classnames = _bind.default.bind(_Checkbox.default);
  var classes = classnames(_constants.CSS_PREFIX, CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), size === 'md'), "".concat(CSS_BLOCK, "--disabled"), disabled), "".concat(CSS_BLOCK, "--inline"), inline), (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "--")).call(_context2, validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state), !!validationMessage));
  var inputClasses = classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__input"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__input--indeterminate"), indeterminate), inputProps === null || inputProps === void 0 ? void 0 : inputProps.className);
  (0, _useUniversalLayoutEffect.default)(function () {
    if (!localInputRef.current) {
      return;
    }
    if (indeterminate) {
      localInputRef.current.indeterminate = true;
    } else {
      localInputRef.current.indeterminate = false;
    }
  });
  var ariaLabel;
  if (!hiddenLabel && validationMessage !== null && validationMessage !== void 0 && validationMessage.text) {
    var _context3;
    ariaLabel = (0, _concat.default)(_context3 = "".concat(label, " ")).call(_context3, validationMessage.text);
  }
  if (hiddenLabel && required) {
    _console.default.warn(_messages.ELEMENT_VALIDATION_WARNINGS.CHECKBOX_HIDDEN_LABEL_REQUIRED);
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _react.default.createElement("label", (0, _extends2.default)({}, otherProps, labelProps, {
      className: classes,
      ref: ref
    }), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, inputProps, {
      "aria-label": ariaLabel,
      checked: isControlled ? !!checked : checked,
      className: inputClasses,
      disabled: disabled,
      onChange: function onChange(e) {
        _onChange === null || _onChange === void 0 || _onChange(!checked, e);
      },
      ref: (0, _reactMergeRefs.default)([localInputRef, inputRef]),
      required: required,
      type: "checkbox"
    })), (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) && (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state) && /*#__PURE__*/_react.default.createElement(_ValidationTooltip.ValidationTooltip, {
      size: size,
      state: validationMessage.state,
      text: validationMessage.text,
      targetClassName: classnames("".concat(CSS_BLOCK, "__validation"))
    }), hiddenLabel ? /*#__PURE__*/_react.default.createElement("span", {
      className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "--screen-reader-only"))
    }, label, " ", validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) : /*#__PURE__*/_react.default.createElement("span", {
      className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__label"), innerTextClassName)
    }, label), !disabled && required && /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true",
      className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__required"))
    }, "*"))
  );
});
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  /** Text label or a React node for **Checkbox** input.  */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  /** @ignore */
  isControlled: _propTypes.default.bool,
  /** When `true`, the **Checkbox** renders as `checked`. */
  checked: _propTypes.default.bool,
  /** Any custom classes to add to the `<label>` element. */
  className: _propTypes.default.string,
  /** Any custom classes to add to the inner `span` element with text. */
  innerTextClassName: _propTypes.default.string,
  /** When `true`, the **Checkbox** gets the `disabled` attribute. */
  disabled: _propTypes.default.bool,
  /** When `true`, the label will not be shown. It will still be present with a
   * `screen-reader-only` class which allows it to be read to assistive technologies. */
  hiddenLabel: _propTypes.default.bool,
  /** When `true`, the **Checkbox** renders a "mixed" state
   * (shows as a "-" in the **Checkbox**). */
  indeterminate: _propTypes.default.bool,
  /** When `true`, **Checkbox** components will be shown on the same row rather than stacked. */
  inline: _propTypes.default.bool,
  /** Attaches a ref to the `<input>` element. */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Other props to be spread onto the `<input>` tag. */
  inputProps: _propTypes.default.object,
  /** Other props to be spread onto the `<label>` tag. */
  labelProps: _propTypes.default.object,
  /** Adds the `required` attribute to the `<input>` element.
   *
   * NOTE: This does not perform any validation, but rather just marks the field as required. */
  required: _propTypes.default.bool,
  /** Size of the `<label>` element. Options are `'lg'` and `'md'`. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** An object identifying a validation message.
   * The object will include properties for `state` and `text`;
   * _e.g._, `{ state: 'warning', text: 'This is your last warning' }`.
   *
   * The options for `state` are `'error'` and `'warning'`.
   *
   * `text` is the message shown in the validation tooltip;
   * as with all text, it must be localized. */
  validationMessage: _propTypes.default.shape({
    state: _propTypes.default.oneOf(_constants.FORM_CONTROL_VALIDATION_STATES).isRequired,
    text: _propTypes.default.string.isRequired
  }),
  /** Callback function for onChange events.
   * @param {boolean} checked
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   */
  onChange: _propTypes.default.func
};
var _default = exports.default = Checkbox;